<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE ref="auditUpdate"  @submit="auditClick" :updateData="auditData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    let type = {"0":window.$t("other.wealth.shortEssay"),"1": window.$t("other.wealth.longEssay")};
    let articleStatus={"1":window.$t("other.wealth.pass"),"2":window.$t("other.wealth.noPass")};
    let articleStatus2={"0":window.$t("other.wealth.notAudit"),"1":window.$t("other.wealth.pass"),"2":window.$t("other.wealth.noPass")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        mounted(){
        },
        methods: {
            auditClick(row){
                this.$axios.get(`${Url.wealthArticle.update}/${row.id}`+'?status='+row.articleStatus).then(res => {
                    if (res.code == 0){
                        this.$refs.auditUpdate.close();
                        this.$refs.childTable.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
              this.$refs.childUpdate.open(row);
            }else if (clickName == "delete"){
                this.$axios.get(`${Url.wealthArticle.deleteBatchId}/${row.id}`).then(res => {
                  if (res.code == 0){
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                  }else{
                    this.$message.error(res.message);
                  }
                });
            }else if (clickName == "updateStatus"){
                if(row.articleStatus == 0){
                    this.$refs.auditUpdate.open(row);
                }else{
                    let status = row.articleStatus == 1 ? 2:1;
                    let conf = row.articleStatus == 1 ? window.$t("other.wealth.noPass"):window.$t("other.wealth.pass");
                    this.$confirm(window.$t("common.ok")+conf, window.$t("common.tip"), {
                        distinguishCancelAndClose: true,
                        confirmButtonText: window.$t("common.ok"),
                        cancelButtonText: window.$t("common.cancle")
                    }).then(() => {
                        this.$axios.get(`${Url.wealthArticle.update}/${row.id}`+'?status='+status).then(res => {
                            if (res.code == 0){
                                this.$refs.childTable.defaultGetData(this.queryData);
                                this.$message.success("suc");
                            }else{
                                this.$message.error(res.message);
                            }
                        });
                    })
                }
            }else if(clickName == "practice"){
                this.$router.push({path:"/other/wealth/commentsList", query: { articleId: row.id ,type:row.type,title:row.title,content:row.content,label:'OHTER'} })
            }
          },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(window.$t("common.search") == clickName || "查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if( window.$t("common.add")==clickName){
                  this.$refs.childUpdate.open();
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                //根据是否包含id更新还是添加
                this.dataChanage(Url.wealthArticle.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })

            },
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: '主键', field: 'id',hidden:true},
                        { title: window.$t("other.wealth.type"), field: 'type',type:3,optionList:type,isNumber:true,data:0,required:true},
                        { title: window.$t("other.wealth.title"), field: 'title',required:(model,col)=>{
                                return model.type == 1;
                            },hidden:(model,col)=>{
                            return model.type == 0;
                            }},
                        { title: window.$t("other.wealth.readRandomCount"), field: 'readRandomCount',type:7,required:true,data:0,min:0,precision:0},
                        { title: window.$t("other.wealth.supportRandomCount"), field: 'supportRandomCount',type:7,required:true,data:0,min:0,precision:0},
                        { title: window.$t("other.wealth.content"), field: 'content',type:6,uploadUrl:Url.img.upload,required:true}
                    ]
                },

                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[

                        { title: window.$t("other.wealth.audit"), field: 'articleStatus',type:2,optionList:articleStatus2,isNumber:true,required:true},
                        {click:window.$t("common.search")},
                        {click: window.$t("common.add")},
                    ]
                },
                auditData:{
                    hasLable: true,
                    cols:[
                        { title: '主键', field: 'id',hidden:true},
                        { title: window.$t("other.wealth.audit"), field: 'articleStatus',type:3,optionList:articleStatus,isNumber:true,data:1},
                    ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.wealthArticle.query,
                    selection: false,
                    sequence: true,
                  method:"get",
                    cols: [
                        { title: window.$t("other.wealth.title"), field: 'title'},
                        { title: window.$t("other.wealth.type"), field: 'type',render:(data)=>{
                                return type[data];
                            }},
                        { title: window.$t("other.wealth.content"), field: 'content',render:(data)=>{
                                return data.length > 15 ?  data.substring(0,15)+'...':data;
                            }},
                        { title: window.$t("other.wealth.author"), field: 'author'},
                        { title: window.$t("other.wealth.createTime"), field: 'createTime'},
                        { title: window.$t("other.wealth.readRandomCount"), field: 'readRandomCount'},
                        { title: window.$t("other.wealth.readRealCount"), field: 'readRealCount'},
                        { title: window.$t("other.wealth.readTotalCount"), field: 'readTotalCount'},
                        { title: window.$t("other.wealth.commentCount"), field: 'commentCount'},
                        { title: window.$t("other.wealth.supportRandomCount"), field: 'supportRandomCount'},
                        { title: window.$t("other.wealth.supportRealCount"), field: 'supportRealCount'},
                        { title: window.$t("other.wealth.supportTotalCount"), field: 'supportTotalCount'},
                        { title: window.$t("common.handle"),width:'370px',btnClick:[
                          {
                            name: window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit"
                          },
                          {
                                    name:(data,full)=>{
                                        if(full.articleStatus == 0){
                                            return window.$t("other.wealth.audit")
                                        }else if(full.articleStatus == 1){
                                            return window.$t("other.wealth.noPass")
                                        }else{
                                            return window.$t("other.wealth.pass")
                                        }
                                    },click:"updateStatus",type:"primary",icon:"el-icon-delete",confirm:false
                           },
                          {
                            name: window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete"
                          },
                            {
                              name:window.$t("other.wealth.queryComment"),click:"practice",type:"primary",icon:"el-icon-edit"
                            }
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
